<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <!-- <app-breadcrumb></app-breadcrumb> -->
                <h2>{{description?.Title}}</h2>
                <p class="text-primary size18 font-weight-semibold">{{description?.Contenu}}
                </p>
                <!-- <p *ngIf="!isclicked" class="font-weight-semibold text-uppercase">{{"AppelOffre.chercher" | translate}}</p> -->
            </div>
        </div>
    </div>

    <div class="container">
    <div class="row">
        <div class="col-md-3 side-bar">
        <div class="selected-item">      </div> 
        <nav id="sidebar">
          <app-statique-menu
            [lg]="outputLg"
            [cururl]="currentUrl"
          ></app-statique-menu>
        </nav>
      </div>
    </div>
  </div>

    
    <section class="c-appels-offres">
        <div class="container">
            <table id="offres" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th>Port</th>
                        <th>Date de Consignation</th>
                        <th>Nature</th>
                        <th>Cause de Consignation</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let consign of consignations">
                        <td>{{consign.Port}}</td>
                        <td>{{consign.DateConsignation}}</td>
                        <td>{{consign.Nature}}</td>
                        <td>{{consign.CauseConsignation}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</main>